import { render, staticRenderFns } from "./totalReport.vue?vue&type=template&id=598f61d0"
import script from "./totalReport.vue?vue&type=script&lang=js"
export * from "./totalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports